import apiClient from '@services/apiClient.ts';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { CC_FEATURE_FLAGS } from 'types/layout.ts';

import { useBankProfile } from '../contexts/BankProfileContext';

export interface FeatureFlag {
	name: string;
	enabled: boolean;
}

interface FeatureFlagsResponse {
	data: FeatureFlag[];
}

const fetchCCFeatureFlags = async (
	selectedProfileId: string | undefined,
): Promise<FeatureFlagsResponse> => {
	const response = await apiClient.post<FeatureFlagsResponse>(
		`/profiles/${selectedProfileId}/feature-flags`,
		{
			keys: [
				CC_FEATURE_FLAGS.DEVICE_LIST,
				CC_FEATURE_FLAGS.ADDRESS_ALIGNMENT,
				CC_FEATURE_FLAGS.WITH_RESTRICTED_IBANS,
				CC_FEATURE_FLAGS.LEGAL_CONSENT_SCREEN,
			],
		},
	);

	return response.data;
};

export const useCCFeatureFlags = (): UseQueryResult<FeatureFlagsResponse, Error> => {
	const { selectedProfile } = useBankProfile();

	return useQuery({
		queryKey: ['cc-feature-flags', selectedProfile?.id],
		queryFn: () => fetchCCFeatureFlags(selectedProfile?.id),
		enabled: Boolean(selectedProfile?.id),
	});
};
